import { createSlice } from '@reduxjs/toolkit'
import { showAlert } from '../../functions/show_alert';
import { requestState } from '../../global/http_enum'
export const projectSlice = createSlice({
    name: 'projects',

    initialState: {
        requestState: requestState.initial,
        gridview: true,
        project: [],
        projectSelected: null,
    },
    reducers: {
        changeGridView: (state, actions) => {
            if (state.gridview) {
                state.gridview = false;
            } else {
                state.gridview = true;
            }
        },
        setProjectData: (state, actions) => {
            const { statusCode, response } = actions.payload;
            if (statusCode === 200) {
                state.project = response;
                state.requestState = requestState.haveData;
            } else if (statusCode === 401) {
                state.requestState = requestState.invalidTokne;
            }
            else if (statusCode > 500) {
                showAlert(false, response);
                state.requestState = requestState.serverError;
            } else {
                showAlert(false, response);
                state.requestState = requestState.internetConnection;
            }
        },
        AddProject: (state, actions) => {
            const projectData = actions.payload;
            const { id, updated_at, name, events, problem } = projectData;
            const newProject = {
                id,
                name,
                event: projectData.event || null,
                problem: Array.isArray(problem) ? problem : [],
                updated_at,
                events: Array.isArray(events) ? events : []
            };
            state.project = [...state.project, newProject];
        },
        requestStatusChanged: (state, action) => {
            state.requestState = requestState.initial;
            state.projectSelected = null
            state.project = [];
        },
        selectProject: (state, actions) => {
            state.projectSelected = actions.payload;
        },
        changeProjectEvent: (state, actions) => {
            const { id, event } = actions.payload;
            var projectTarget = state.project.findIndex((elem) => elem.id === id);
            if (projectTarget === -1) {
                return;
            }
            // Initialize events array if it doesn't exist
            if (!Array.isArray(state.project[projectTarget].events)) {
                state.project[projectTarget].events = [];
            }
            // Add event to array
            state.project[projectTarget].events.push(event);
            // Also update single event for backward compatibility (first event)
            state.project[projectTarget] = { ...state.project[projectTarget], event: event };
            if (state.projectSelected && state.projectSelected.id === id) {
                if (!Array.isArray(state.projectSelected.events)) {
                    state.projectSelected.events = [];
                }
                state.projectSelected.events.push(event);
                state.projectSelected = { ...state.projectSelected, event: event };
            }
        },
        setProjectEvents: (state, actions) => {
            const { id, events } = actions.payload;
            var projectTarget = state.project.findIndex((elem) => elem.id === id);
            if (projectTarget === -1) {
                return;
            }
            state.project[projectTarget].events = events;
            // Set first event for backward compatibility
            state.project[projectTarget].event = events && events.length > 0 ? events[0] : null;
            if (state.projectSelected && state.projectSelected.id === id) {
                state.projectSelected.events = events;
                state.projectSelected.event = events && events.length > 0 ? events[0] : null;
                // Update selectedEvent if it exists, to ensure it has the latest data from the API
                if (state.projectSelected.selectedEvent) {
                    const updatedSelectedEvent = events.find(e => e.id === state.projectSelected.selectedEvent.id);
                    if (updatedSelectedEvent) {
                        state.projectSelected.selectedEvent = updatedSelectedEvent;
                    } else {
                        // If selectedEvent is not found in the new events array, clear it
                        state.projectSelected.selectedEvent = null;
                    }
                }
            }
        },
        selectEvent: (state, actions) => {
            const { eventId } = actions.payload;
            if (state.projectSelected && state.projectSelected.events) {
                const selectedEvent = state.projectSelected.events.find(e => e.id === eventId);
                if (selectedEvent) {
                    state.projectSelected.selectedEvent = selectedEvent;
                }
            }
        },
        deleteEventByID: (state, actions) => {
            const { projectId, eventId } = actions.payload;
            var projectTarget = state.project.findIndex((elem) => elem.id === projectId);
            if (projectTarget === -1) {
                return;
            }
            if (Array.isArray(state.project[projectTarget].events)) {
                state.project[projectTarget].events = state.project[projectTarget].events.filter(e => e.id !== eventId);
                // Update single event for backward compatibility
                state.project[projectTarget].event = state.project[projectTarget].events.length > 0 ? state.project[projectTarget].events[0] : null;
            }
            if (state.projectSelected && state.projectSelected.id === projectId) {
                if (Array.isArray(state.projectSelected.events)) {
                    state.projectSelected.events = state.projectSelected.events.filter(e => e.id !== eventId);
                    state.projectSelected.event = state.projectSelected.events.length > 0 ? state.projectSelected.events[0] : null;
                    // Clear selected event if it was deleted
                    if (state.projectSelected.selectedEvent && state.projectSelected.selectedEvent.id === eventId) {
                        state.projectSelected.selectedEvent = null;
                    }
                }
            }
        },
        updateEventDomain: (state, actions) => {
            const { projectId, eventId, newDomain } = actions.payload;
            var projectTarget = state.project.findIndex((elem) => elem.id === projectId);
            if (projectTarget === -1) {
                return;
            }
            if (Array.isArray(state.project[projectTarget].events)) {
                const eventIndex = state.project[projectTarget].events.findIndex(e => e.id === eventId);
                if (eventIndex !== -1) {
                    state.project[projectTarget].events[eventIndex] = {
                        ...state.project[projectTarget].events[eventIndex],
                        domain: newDomain
                    };
                    // Update single event if it's the one being updated
                    if (state.project[projectTarget].event && state.project[projectTarget].event.id === eventId) {
                        state.project[projectTarget].event = {
                            ...state.project[projectTarget].event,
                            domain: newDomain
                        };
                    }
                }
            }
            if (state.projectSelected && state.projectSelected.id === projectId) {
                if (Array.isArray(state.projectSelected.events)) {
                    const eventIndex = state.projectSelected.events.findIndex(e => e.id === eventId);
                    if (eventIndex !== -1) {
                        state.projectSelected.events[eventIndex] = {
                            ...state.projectSelected.events[eventIndex],
                            domain: newDomain
                        };
                        if (state.projectSelected.event && state.projectSelected.event.id === eventId) {
                            state.projectSelected.event = {
                                ...state.projectSelected.event,
                                domain: newDomain
                            };
                        }
                        if (state.projectSelected.selectedEvent && state.projectSelected.selectedEvent.id === eventId) {
                            state.projectSelected.selectedEvent = {
                                ...state.projectSelected.selectedEvent,
                                domain: newDomain
                            };
                        }
                    }
                }
            }
        },
        changeProjectProblem: (state, actions) => {
            const { id, problem } = actions.payload;
            const projectTargetIndex = state.project.findIndex((elem) => elem.id === id);

            if (projectTargetIndex === -1) {
                return; // Project not found, exit the function
            }

            // Check if the 'problem' property exists and is an array, if not, initialize it as an array
            if (!Array.isArray(state.project[projectTargetIndex].problem)) {
                state.project[projectTargetIndex].problem = [];
            }

            // Append the new problem to the existing list of problems
            state.project[projectTargetIndex].problem.push(problem);

            // Assuming state.projectSelected should also reflect this change if it's the same project
            if (state.projectSelected && state.projectSelected.id === id) {
                if (!Array.isArray(state.projectSelected.problem)) {
                    state.projectSelected.problem = [];
                }
                state.projectSelected.problem.push(problem);
            }
        },

        deleteProjectByID: (state, actions) => {
            if (state.projectSelected != null) {
                if (state.projectSelected.id === actions.payload) {
                    state.projectSelected = null
                }
            }
            state.project = state.project.filter(obj => obj.id !== actions.payload)
        },
        editProjectByID: (state, actions) => {
            const { id, projectName } = actions.payload;
            const updatedList = state.project.map(obj =>
                obj.id === id ? { ...obj, name: projectName } : obj
            );

            state.project = updatedList;
            if (state.projectSelected !== null && id === state.projectSelected.id) {
                state.projectSelected = { ...state.projectSelected, name: projectName }
            }
        },
        editProjectDomainByID: (state, actions) => {
            const { id, newDomain, eventId } = actions.payload;
            // If eventId is provided, use updateEventDomain instead
            if (eventId) {
                // This is handled by updateEventDomain
                return;
            }
            // Legacy: update first event's domain
            const updatedList = state.project.map(project =>
                project.id === id
                    ? {
                        ...project,
                        event: project.event ? {
                            ...project.event,
                            domain: newDomain
                        } : null
                    }
                    : project
            );
            state.project = updatedList;
            if (state.projectSelected !== null && id === state.projectSelected.id) {
                state.projectSelected = {
                    ...state.projectSelected,
                    event: state.projectSelected.event ? {
                        ...state.projectSelected.event,
                        domain: newDomain
                    } : null
                };
            }
        },
    }
});

export const { changeGridView, requestStatusChanged, setProjectData, AddProject, selectProject, changeProjectEvent, changeProjectProblem, deleteProjectByID, editProjectByID, editProjectDomainByID, setProjectEvents, selectEvent, deleteEventByID, updateEventDomain } = projectSlice.actions

export default projectSlice.reducer